import { RehearsalScene } from './rehearsal-scene';
import { ShowPerformance } from '../../models/showperformance.model';
import { IRehearsal } from './i-rehearsal.interface';

export class RehearsalRequest implements IRehearsal{
    public performance: ShowPerformance;
    public scenes: RehearsalScene[] = [];
    public purpose: string = '';
    public notes: string = '';
    public personName: string = '';
}
